// frontend/src/config.ts

const API_URL = import.meta.env.VITE_API_URL;
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

// We no longer throw an error here, allowing main.tsx to handle it.

const normalizeUrl = (u: string | undefined) => {
  if (!u) return "";
  return u.replace(/\s+$/, "").replace(/\/+$/, "");
};

// API_BASE_URL alias for backward compatibility
const API_BASE_URL = API_URL;

export { API_URL, API_BASE_URL, GOOGLE_CLIENT_ID, normalizeUrl };